import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EventDetailComponent, EventDetails } from '@softapps/core/events';

/** Modal wrapper around the shared read-only event detail view. */
@Component({
  selector: 'soft-external-event-modal',
  templateUrl: './external-event-modal.component.html',
  imports: [EventDetailComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalEventModalComponent {
  readonly details = input.required<EventDetails>();
}
